module.exports = __webpack_public_path__ + "img/icon-warning-skogbrannfare-4.3cfa5c80.svg";